module.exports = __webpack_public_path__ + "img/37.9d2b024e.png";